/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDcjp5%7Bborder-radius%3Avar(--ds-radius-xsmall%2C2px)%7D%0A._0WKd3G4z3T%7Bfont-family%3Avar(--ds-font-family-body%2C%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._2nTuUYWfPD%3Avisited%7Bcolor%3Avar(--ds-link-visited%2C%23803fa5)%7D%0A._3ADzdEWfPD%3Avisited%3Afocus%7Bcolor%3Avar(--ds-link-visited%2C%23803fa5)%7D%0A._1warJ9WfPD%3Avisited%3Ahover%7Bcolor%3Avar(--ds-link-visited%2C%23803fa5)%7D%0A._4scvAwWyeI%3Avisited%3Aactive%7Bcolor%3Avar(--ds-link-visited-pressed%2C%2348245d)%7D%0A._00uqCY98eZ%7Btext-decoration-color%3AcurrentColor%7D%0A._3xtjKN0Rl6%7Btext-decoration-line%3Aunderline%7D%0A._0H9qDF6wH8%7Btext-decoration-style%3Asolid%7D%0A._23rrnHo10F%7Btransition%3Avar(--ds-listitem-hovered%2Cbackground-color%20border-color%20color%20text-decoration-color%2050ms%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._1UtDYzM7Tp%7Bcolor%3Avar(--ds-link%2C%231868db)%7D%0A._32C2rk98eZ%3Afocus%7Btext-decoration-color%3AcurrentColor%7D%0A._0i9AWA0Rl6%3Afocus%7Btext-decoration-line%3Aunderline%7D%0A._0mm6KQ6wH8%3Afocus%7Btext-decoration-style%3Asolid%7D%0A._10n1R5M7Tp%3Afocus%7Bcolor%3Avar(--ds-link%2C%231868db)%7D%0A._0DCa9DjOvk%3Ahover%7Btext-decoration-color%3Atransparent%7D%0A._3932vv0Rl6%3Ahover%7Btext-decoration-line%3Aunderline%7D%0A._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0A._1B4rbIo10F%3Ahover%7Btransition%3Avar(--ds-listitem-hovered%2Cbackground-color%20border-color%20color%20text-decoration-color%2050ms%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._0clgaMM7Tp%3Ahover%7Bcolor%3Avar(--ds-link%2C%231868db)%7D%0A._3WzCGijOvk%3Aactive%7Btext-decoration-color%3Atransparent%7D%0A._0NqVRt0Rl6%3Aactive%7Btext-decoration-line%3Aunderline%7D%0A._3BKYwu6wH8%3Aactive%7Btext-decoration-style%3Asolid%7D%0A._3sFUREDdj4%3Aactive%7Btransition%3Avar(--ds-listitem-pressed%2Cbackground-color%20border-color%20color%20text-decoration-color%20.1s%20cubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._0CMRbkAwSC%3Aactive%7Bcolor%3Avar(--ds-link-pressed%2C%231558bc)%7D%0A._00uqCYjOvk%7Btext-decoration-color%3Atransparent%7D%0A._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._32C2rkjOvk%3Afocus%7Btext-decoration-color%3Atransparent%7D%0A._10n1R5ZpcK%3Afocus%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0A._0clgaMZpcK%3Ahover%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._3WzCGi98eZ%3Aactive%7Btext-decoration-color%3AcurrentColor%7D%0A._0CMRbky7kJ%3Aactive%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._2nTuUYe5R3%3Avisited%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._10n1R5e5R3%3Afocus%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0clgaMe5R3%3Ahover%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0CMRbke5R3%3Aactive%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._3iDTPbS8kF%7Bdisplay%3Ainline%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._1RrJLiQame%7Bvertical-align%3Abaseline%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._2I62gzVQEB%7Binset-block-start%3A.11em%7D%0A._39xV02YsW8%7Bwidth%3A.9em%7D%0A._0jFU0VYsW8%7Bheight%3A.9em%7D%0A._0GTcwRu3qR%7Bmargin-inline-start%3A.3em%7D");













































import { type AnchorHTMLAttributes, forwardRef, type Ref } from 'react';
import type { RouterLinkComponentProps } from '@atlaskit/app-provider/router-link-provider';
import { cx } from '@atlaskit/css';
import { Anchor, type AnchorProps } from '@atlaskit/primitives/compiled/anchor';
import { Box } from '@atlaskit/primitives/compiled/box';
const styles = {
  base: "_0bjKvDcjp5 _0WKd3G4z3T",
  visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
  defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
  subtleAppearance: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
  inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
  iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const iconStyles = null;
export type LinkProps<RouterLinkConfig extends Record<string, any> = never> = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick' | 'style' | 'children' | 'className'> & Pick<AnchorProps<RouterLinkConfig>, 'interactionName' | 'analyticsContext' | 'onClick' | 'testId' | 'newWindowLabel'> & RouterLinkComponentProps<RouterLinkConfig> & {
  /**
   * The appearance of the link. Defaults to `default`. A `subtle` appearance will render the link with a lighter color and no underline in resting state. Use `inverse` when rendering on bold backgrounds to ensure that the link is easily visible.
   */
  appearance?: 'default' | 'subtle' | 'inverse';
};
const LinkWithoutRef = <RouterLinkConfig extends Record<string, any> = never,>({
  children,
  testId,
  appearance = 'default',
  newWindowLabel,
  target,
  // @ts-expect-error
  className: _preventedClassName,
  // @ts-expect-error
  style: _preventedStyle,
  ...htmlAttributes
}: LinkProps<RouterLinkConfig>, ref: Ref<HTMLAnchorElement>): JSX.Element => <Anchor
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
{...htmlAttributes} target={target} ref={ref} xcss={cx(styles.base, appearance === 'default' && styles.defaultAppearance, appearance === 'subtle' && styles.subtleAppearance, appearance === 'inverse' && styles.inverseAppearance,
// Visited styles are not supported for inverse links due to contrast issues
appearance !== 'inverse' && styles.visitedLink)} testId={testId} componentName="Link" newWindowLabel={newWindowLabel}>
		{children}
		{target === '_blank' && <Box as="span" xcss={styles.iconWrapper} testId={testId && `${testId}__icon`}>
				{/* Zero-width space to prevent the icon from wrapping onto new line */}
				&#65279;
				{/* Unfortunately Shortcut Icon had to be copied directly below to support visited styles.
          This is because icons have a default `color` and although it's set to inherit text color, due to strict security restrictions for visited links it did not allow the color to pass through to the SVG */}
				<svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={ax(["_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"])}>
					<path fillRule="evenodd" clipRule="evenodd" d="M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z" fill="currentColor" />
				</svg>
			</Box>}
	</Anchor>;
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */
const Link = (forwardRef(LinkWithoutRef) as <RouterLinkConfig extends Record<string, any> = never>(props: LinkProps<RouterLinkConfig> & {
  ref?: Ref<HTMLAnchorElement>;
}) => ReturnType<typeof LinkWithoutRef>);
export default Link;